<template>
  <div class="about" >
    <ChatMessage :messages="this.messages" :thereIsImg="this.thereIsImgCliptoBoard" />
    <BoxCmd @clearImgCopiedFromObj="clearImg" @new="addNewMessage" @pasteImg="getCliptoBoardImg" :thereIsImg="this.thereIsImgCliptoBoard" :imgCopied="this.imgCopied"/>
  </div>
</template>
<script>

import BoxCmd from "../components/BoxCmd.vue";
import ChatMessage from "../components/ChatMessage.vue";

export default {
  name:"About",
  mounted(){
    if(localStorage.getItem('msgs')){
      //await this.sleepTime(2);
      this.messages = JSON.parse(localStorage.getItem('msgs'));
      setTimeout(()=>{
        document.getElementsByClassName("box-h")[0].style.height = "calc(70vh - 80px)";
      },1);
      setTimeout(()=>{
        this.goToEndSroll();
      },1);
    }
  },
  data:()=>({
    thereIsImgCliptoBoard:false,
    imgCopied:null,
    messages:[
        /*{id:1,text:"Hola mundo",img:null},
        {id:2,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:3,text:"Testing",img:null},
        {id:4,text:"Hola mundo2",img:null},
        {id:5,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:6,text:"Testing",img:null},
        {id:7,text:"Hola mundo",img:null},
        {id:8,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:9,text:"Testing",img:null},
        {id:10,text:"Hola mundo",img:null},
        {id:11,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:12,text:"Testing",img:null},
        {id:13,text:"Hola mundo",img:null},
        {id:14,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:15,text:"Testing",img:null},
        {id:16,text:"Hola mundo2",img:null},
        {id:17,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:18,text:"Testing",img:null},
        {id:19,text:"Hola mundo",img:null},
        {id:20,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:21,text:"Testing",img:null},
        {id:22,text:"Hola mundo",img:null},
        {id:23,text:"Segunda Lorem isdawdkandawdn kwandlawdn wakndl awnd lkawndl awndl andl awkndl kandlk anwd",img:null},
        {id:24,text:"Testing",img:null},*/
    ]
  }),
  methods:{
    clearImg(){
      this.thereIsImgCliptoBoard = false;
      this.imgCopied = null;
    },
    async addNewMessage(msg){
      await this.AsyncPushArray(msg);
      this.goToEndSroll();
    },
    async goToEndSroll(){
      document.querySelector(".box-h").scrollTop = document.querySelector(".box-h").scrollHeight;
    },
    async AsyncPushArray(msg){
      return new Promise((resolve,reject)=>{
        this.messages.push(msg)
        localStorage.setItem('msgs',  JSON.stringify(this.messages));
        resolve();
      });
    },
    getCliptoBoardImg(e){
      document.addEventListener("paste",e=>{
        if(e.clipboardData.files.length > 0){
          console.log(e.clipboardData.files);
          if(e.clipboardData.files[0].type.startsWith("image/")){
            this.setPreviewImg(e.clipboardData.files[0]);
          }
        }
      });
    },
    async setPreviewImg(file){
      this.imgCopied = await this.AsyncLoadImg(file);
      //console.log("Hola");
      document.querySelector("#imgPreview").src = this.imgCopied;
      setTimeout(()=>{
        document.getElementsByClassName("box-h-without-img")[0].style.height = "calc(70vh - 80px)";
      },1);
      
    },
    async AsyncLoadImg(file){
      return new Promise((resolve,reject)=>{
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          this.thereIsImgCliptoBoard = true
          //console.log("Img");
          resolve(fileReader.result)
          };
      });
    },
    async sleepTime(s){
      return new Promise((resolve,reject)=>{
        setTimeout(resolve(),s*1000);
      });
    },
  },
  /*watch:{
    messages:(newMsgs)=>{
      localStorage.msgs = newMsgs;
    }
  },*/
  components:{
    BoxCmd,
    ChatMessage,
  }
}
</script>
